/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Card, CardBody, CardTitle, Col, CardImg, Container, Row, CardText} from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'
import { Link } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import ImgChart from '../img/charts-01.png';
import ImgPrint from '../img/charts-02.png';
import TableSubscriptions from './tables/table-subscriptions';
import NavbarMobile from './navbar/navbar-mobile';
import Footer from './footer/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faCogs, faList } from '@fortawesome/free-solid-svg-icons';


// This is the item list
class Dashboard extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });


        this.state = {
            subscriptionsData: null
        };
        this.props.addTranslation(global);
    }


    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return(
            <div>
                <NavbarMobile/>
                <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation} config={{duration:450, easing: Easing.linear}}>
                    {
                        styles =>
                        <Container>
                            <h2 className="font-now-bold white-text">
                                <FontAwesomeIcon icon={faHome} />{' '}
                                <Translate id="dashboard.home" options={{renderInnerHtml: true}}/>
                            </h2>
                            <Row>
                                <Col lg={{size: 3}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card body className="card-orange">
                                        <CardTitle>
                                            <FontAwesomeIcon icon={faUser} />{' '}
                                            <Translate id="dashboard.profiles-add" options={{renderInnerHtml: false}}/></CardTitle>
                                       <Link to="/profile-register" className="btn btn-block btn-outline-light">
                                            <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                        </Link>
                                    </Card>
                                </Col>
                                <Col lg={{size: 3}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card body className="card-yellow">
                                        <CardTitle>
                                            <FontAwesomeIcon icon={faUser} />{' '}
                                            <Translate id="dashboard.profiles-edit" options={{renderInnerHtml: false}}/></CardTitle>
                                         <Link to="/profile-update" className="btn btn-block btn-outline-light">
                                            <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                        </Link>
                                    </Card>
                                </Col>
                                <Col lg={{size: 3}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card body className="card-cyan">
                                        <CardTitle>
                                            <FontAwesomeIcon icon={faList} />{' '}
                                            <Translate id="dashboard.syllabus" options={{renderInnerHtml: false}}/></CardTitle>
                                        <Link to="/syllabus" className="btn btn-block btn-outline-light">
                                            <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                        </Link>
                                    </Card>
                                </Col>
                                <Col lg={{size: 3}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card body className="card-green">
                                        <CardTitle>
                                            <FontAwesomeIcon icon={faCogs} />{' '}
                                            <Translate id="dashboard.settings" options={{renderInnerHtml: false}}/>
                                        </CardTitle>
                                        <Link to="/update-information" className="btn btn-block btn-outline-light">
                                            <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                        </Link>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col log={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card className="card-red">
                                        <CardImg top width="100%" src={ImgChart} alt={ImgChart} />
                                        <CardBody>
                                            <CardTitle><Translate id="dashboard.profile-analysis" options={{renderInnerHtml: false}}/></CardTitle>
                                            <CardText><Translate id="dashboard.profile-analysis-subtitle" options={{renderInnerHtml: false}}/></CardText>
                                            <CardText>
                                                <Link to="/report-average" className="btn btn-block btn-outline-light">
                                                    <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                                </Link>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col log={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                    <Card className="card-blue">
                                        <CardImg top width="100%" src={ImgPrint} alt={ImgPrint} />
                                        <CardBody>
                                            <CardTitle><Translate id="dashboard.results" options={{renderInnerHtml: false}}/></CardTitle>
                                            <CardText><Translate id="dashboard.results-subtitle" options={{renderInnerHtml: false}}/></CardText>
                                            <CardText>
                                                <Link to="/report-results" className="btn btn-block btn-outline-light">
                                                    <Translate id="dashboard.enter" options={{renderInnerHtml: false}}/>
                                                </Link>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <hr/>
                            <Row>
                                <Col lg="12" sm="12" md="12" xs="12">
                                    <h2 className="font-now-bold white-text">
                                        <Translate id="subscriptions.my-subscriptions" options={{renderInnerHtml: false}}/>
                                    </h2>
                                    <TableSubscriptions/>
                                </Col>
                            </Row>
                        </Container>
                    }
                </Spring>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(Dashboard);


// WEBPACK FOOTER //
// ./src/components/dashboard.js